module.exports = __webpack_public_path__ + "static/pitreflections-5046208aaf59a13d00ea774432a99fec.mp3";